import { ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CardButtonProps {
	icon: React.ReactNode
	iconBg: string
	borderColor: string
	title: string
	description: string
	disabled?: boolean
	onClick?: () => void
}

export const CardButton = ({
	icon,
	iconBg,
	borderColor,
	title,
	description,
	disabled = false,
	onClick,
}: CardButtonProps) => {
	return (
		<button
			type="button"
			disabled={disabled}
			onClick={onClick}
			className={cn(
				'group flex h-full min-h-28 items-center gap-4 rounded-xl border border-l-4 bg-card px-4 py-4 text-left shadow-sm transition-all sm:px-5 sm:py-3.5',
				borderColor,
				disabled
					? 'cursor-not-allowed opacity-40'
					: 'cursor-pointer hover:shadow-md active:scale-[0.99]',
			)}
		>
			{/* Icon */}
			<div
				className={cn(
					'flex size-11 shrink-0 items-center justify-center rounded-lg',
					iconBg,
				)}
			>
				{icon}
			</div>

			{/* Text */}
			<div className="flex-1 min-w-0">
				<span className="block text-base font- text-kaefer-dark-grey">
					{title}
				</span>
				<span className="mt-0.5 block text-sm text-muted-foreground leading-tight">
					{description}
				</span>
			</div>

			{/* Chevron */}
			{!disabled && (
				<ChevronRight className="size-5 shrink-0 text-muted-foreground/60 transition-transform group-hover:translate-x-0.5" />
			)}
		</button>
	)
}
